export const REGIONS = {
  "West Africa": {
    Nigeria: [
      "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa",
      "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti",
      "Enugu", "FCT (Abuja)", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano",
      "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger",
      "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto",
      "Taraba", "Yobe", "Zamfara",
    ],
    Ghana: [
      "Ahafo", "Ashanti", "Bono", "Bono East", "Central", "Eastern",
      "Greater Accra", "North East", "Northern", "Oti", "Savannah",
      "Upper East", "Upper West", "Volta", "Western", "Western North",
    ],
    "Côte d'Ivoire": [
      "Abidjan", "Bas-Sassandra", "Comoé", "Denguélé", "Gôh-Djiboua",
      "Lacs", "Lagunes", "Montagnes", "Sassandra-Marahoué", "Savanes",
      "Vallée du Bandama", "Woroba", "Yamoussoukro", "Zanzan",
    ],
    Senegal: [
      "Dakar", "Diourbel", "Fatick", "Kaffrine", "Kaolack", "Kédougou",
      "Kolda", "Louga", "Matam", "Saint-Louis", "Sédhiou",
      "Tambacounda", "Thiès", "Ziguinchor",
    ],
    Mali: [
      "Bamako", "Gao", "Kayes", "Kidal", "Koulikoro", "Ménaka",
      "Mopti", "Ségou", "Sikasso", "Taoudénit",
    ],
    "Burkina Faso": [
      "Boucle du Mouhoun", "Cascades", "Centre", "Centre-Est",
      "Centre-Nord", "Centre-Ouest", "Centre-Sud", "Est", "Hauts-Bassins",
      "Nord", "Plateau-Central", "Sahel", "Sud-Ouest",
    ],
    Guinea: [
      "Boké", "Conakry", "Faranah", "Kankan", "Kindia",
      "Labé", "Mamou", "Nzérékoré",
    ],
    Benin: [
      "Alibori", "Atakora", "Atlantique", "Borgou", "Collines",
      "Couffo", "Donga", "Littoral", "Mono", "Ouémé", "Plateau", "Zou",
    ],
    Togo: [
      "Centrale", "Kara", "Maritime", "Plateaux", "Savanes",
    ],
    "Sierra Leone": [
      "Eastern Province", "North West Province", "Northern Province",
      "Southern Province", "Western Area",
    ],
    Liberia: [
      "Bomi", "Bong", "Gbarpolu", "Grand Bassa", "Grand Cape Mount",
      "Grand Gedeh", "Grand Kru", "Lofa", "Margibi", "Maryland",
      "Montserrado", "Nimba", "River Cess", "River Gee", "Sinoe",
    ],
    "Guinea-Bissau": [
      "Bafatá", "Biombo", "Bolama", "Cacheu", "Gabú",
      "Oio", "Quinara", "Tombali",
    ],
    Gambia: [
      "Banjul", "Central River", "Lower River",
      "North Bank", "Upper River", "West Coast",
    ],
    "Cape Verde": [
      "Barlavento Islands", "Sotavento Islands",
    ],
    Mauritania: [
      "Adrar", "Assaba", "Brakna", "Dakhlet Nouadhibou", "Gorgol",
      "Guidimaka", "Hodh Ech Chargui", "Hodh El Gharbi", "Inchiri",
      "Nouakchott-Nord", "Nouakchott-Ouest", "Nouakchott-Sud",
      "Tagant", "Tiris Zemmour", "Trarza",
    ],
    Niger: [
      "Agadez", "Diffa", "Dosso", "Maradi", "Niamey",
      "Tahoua", "Tillabéri", "Zinder",
    ],
  },
  "Central Africa": {
    Cameroon: [
      "Adamawa", "Centre", "East", "Far North", "Littoral",
      "North", "North West", "South", "South West", "West",
    ],
    "DR Congo": [
      "Bas-Uélé", "Équateur", "Haut-Katanga", "Haut-Lomami", "Haut-Uélé",
      "Ituri", "Kasaï", "Kasaï-Central", "Kasaï-Oriental", "Kinshasa",
      "Kongo Central", "Kwango", "Kwilu", "Lomami", "Lualaba",
      "Mai-Ndombe", "Maniema", "Mongala", "Nord-Kivu", "Nord-Ubangi",
      "Sankuru", "Sud-Kivu", "Sud-Ubangi", "Tanganyika", "Tshopo", "Tshuapa",
    ],
    "Republic of Congo": [
      "Bouenza", "Brazzaville", "Cuvette", "Cuvette-Ouest", "Kouilou",
      "Lékoumou", "Likouala", "Niari", "Plateaux", "Pointe-Noire",
      "Pool", "Sangha",
    ],
    Gabon: [
      "Estuaire", "Haut-Ogooué", "Moyen-Ogooué", "Ngounié",
      "Nyanga", "Ogooué-Ivindo", "Ogooué-Lolo", "Ogooué-Maritime",
      "Woleu-Ntem",
    ],
    "Central African Republic": [
      "Bamingui-Bangoran", "Bangui", "Basse-Kotto", "Haute-Kotto",
      "Haut-Mbomou", "Kémo", "Lobaye", "Mambéré-Kadéï", "Mbomou",
      "Nana-Grébizi", "Nana-Mambéré", "Ombella-M'Poko", "Ouaka",
      "Ouham", "Ouham-Pendé", "Sangha-Mbaéré", "Vakaga",
    ],
    Chad: [
      "Bahr el Gazel", "Batha", "Borkou", "Chari-Baguirmi", "Ennedi Est",
      "Ennedi Ouest", "Guéra", "Hadjer-Lamis", "Kanem", "Lac",
      "Logone Occidental", "Logone Oriental", "Mandoul", "Mayo-Kebbi Est",
      "Mayo-Kebbi Ouest", "Moyen-Chari", "N'Djamena", "Ouaddaï",
      "Salamat", "Sila", "Tandjilé", "Tibesti", "Wadi Fira",
    ],
    "Equatorial Guinea": [
      "Annobón", "Bioko Norte", "Bioko Sur", "Centro Sur",
      "Djibloho", "Kié-Ntem", "Litoral", "Wele-Nzas",
    ],
    "São Tomé and Príncipe": [
      "Príncipe", "São Tomé",
    ],
  },
};

// Lagos is split into two assignment zones because sales/account specialists
// there cover Island vs. Mainland separately rather than the whole state.
export const LAGOS_ZONES = {
  Mainland: [
    "Ikeja", "Yaba", "Surulere", "Apapa", "Oshodi", "Isolo", "Mushin",
    "Maryland", "Gbagada", "Ketu", "Ojota", "Ogba", "Agege", "Ifako-Ijaiye",
    "Alimosho", "Ikotun", "Egbeda", "Ejigbo", "Festac Town", "Amuwo-Odofin",
    "Ojo", "Badagry", "Ikorodu", "Shomolu", "Bariga", "Ogudu", "Anthony Village",
  ],
  Island: [
    "Lagos Island", "Victoria Island", "Ikoyi", "Lekki Phase 1", "Lekki",
    "Ajah", "Sangotedo", "Chevron", "Eko Atlantic", "Oniru", "Epe",
  ],
};

export function getLagosCities() {
  return Object.entries(LAGOS_ZONES).flatMap(([zone, cities]) =>
    cities.map((city) => ({ city, zone }))
  );
}

export function getZoneForLagosCity(city) {
  for (const [zone, cities] of Object.entries(LAGOS_ZONES)) {
    if (cities.includes(city)) return zone;
  }
  return null;
}

export function getStatesByCountry(country) {
  for (const countries of Object.values(REGIONS)) {
    if (countries[country]) return countries[country];
  }
  return [];
}

export function getAllCountries() {
  return Object.entries(REGIONS).flatMap(([region, countries]) =>
    Object.keys(countries).map((country) => ({ country, region }))
  );
}